import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';

class GamesModel extends Network {
  constructor(baseURL: string, timeout = 120000) {
    super(baseURL, timeout);
  }

  //GET
  //Получить актуальный стейт миниапа
  async getState<T>(): Promise<T> {
    return this.send('get', `/mini_app/state`);
  }

  //Получить актуальный стейт миниапа
  async getGameState<T>(gameId): Promise<T> {
    return this.send('get', `/mini_app/games/${gameId}/state`);
  }

  //Получить рейтинг камень ножницы бумага
  async getGameRating<T>(): Promise<T> {
    return this.send('get', `/mini_app/games/scores/rock_scissors_paper`);
  }

  //Получить друзей в игре камень ножницы бумага
  async getGameFriends<T>(): Promise<T> {
    return this.send('get', `/mini_app/friends/rock_scissors_paper`);
  }

  //POST

  //Начать новую игру, присоединиться к игре
  async postPlayGame<T>(gameName: string): Promise<T> {
    return this.send('post', `/mini_app/games/play/${gameName}`);
  }

  //Покинуть игру
  async postLeaveGame<T>(gameId: string): Promise<T> {
    return this.send('post', `/mini_app/games/leave/${gameId}`);
  }

  //Сделать ход в игре
  async postMoveGame<T>(data: { game_id: string; action: string }): Promise<T> {
    const { game_id, ...rest } = data;
    return this.send('post', `/mini_app/games/move/${game_id}`, { ...rest });
  }

  //Принять участие в новом раунде
  async postJoinNextRoundGame<T>(data: { game_id: string }): Promise<T> {
    const { game_id } = data;
    return this.send('post', `/mini_app/games/start_round/${game_id}`);
  }

  //Завершить игру с  просроченным ходом своим или соперника
  async postCompleteNoMove<T>(data: { game_id: string }): Promise<T> {
    const { game_id } = data;
    return this.send('post', `/mini_app/games/${game_id}/complete-no-move`);
  }

  //Продлить ожидание соперника
  async postContinueAwaiting<T>(data: { game_id: string }): Promise<T> {
    const { game_id } = data;
    return this.send('post', `/mini_app/games/continue-awaiting/${game_id}`);
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BASE_URL as string;
const gamesModel = new GamesModel(baseUrl);
export default gamesModel;
